var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVeTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_772_35516)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34017 11.514C7.30641 11.5677 7.28764 11.6294 7.28582 11.6928C7.284 11.7562 7.29919 11.8189 7.32981 11.8744C7.36044 11.93 7.40537 11.9763 7.45995 12.0086C7.51453 12.0408 7.57676 12.0579 7.64017 12.058H11.6932C11.7236 12.0579 11.7535 12.0659 11.7797 12.0812C11.806 12.0966 11.8276 12.1187 11.8424 12.1452C11.8572 12.1718 11.8646 12.2018 11.8639 12.2322C11.8632 12.2626 11.8543 12.2922 11.8382 12.318L7.86017 18.687C7.85027 18.7034 7.83716 18.7176 7.82163 18.7288C7.80609 18.74 7.78845 18.748 7.76977 18.7522C7.75109 18.7564 7.73174 18.7568 7.71291 18.7533C7.69408 18.7498 7.67614 18.7426 7.66017 18.732C6.22696 17.8062 5.1269 16.4468 4.5203 14.852C3.9137 13.2572 3.83227 11.5104 4.28788 9.86608C4.74349 8.22178 5.71232 6.76596 7.05318 5.71078C8.39404 4.65561 10.0368 4.05624 11.7422 4.00001C11.7674 3.99966 11.7923 4.0061 11.8143 4.01866C11.8362 4.03122 11.8543 4.04944 11.8668 4.07141C11.8793 4.09339 11.8856 4.11831 11.8851 4.14357C11.8847 4.16883 11.8774 4.19351 11.8642 4.21501L7.34017 11.514ZM16.4802 5.36901C16.4644 5.35807 16.4466 5.35047 16.4278 5.3467C16.409 5.34293 16.3896 5.34307 16.3708 5.3471C16.3521 5.35113 16.3344 5.35897 16.3188 5.37014C16.3032 5.38131 16.29 5.39556 16.2802 5.41201L12.3632 11.687C12.3471 11.7127 12.3382 11.7423 12.3375 11.7726C12.3367 11.8029 12.344 11.8329 12.3587 11.8594C12.3734 11.8859 12.3949 11.908 12.421 11.9234C12.4471 11.9388 12.4769 11.947 12.5072 11.947H16.5602C16.6236 11.9471 16.6858 11.9642 16.7404 11.9965C16.795 12.0287 16.8399 12.0751 16.8705 12.1306C16.9012 12.1861 16.9163 12.2488 16.9145 12.3122C16.9127 12.3756 16.8939 12.4373 16.8602 12.491L12.2782 19.829C12.2674 19.8463 12.2616 19.8662 12.2613 19.8866C12.261 19.907 12.2663 19.9271 12.2766 19.9447C12.2869 19.9622 12.3018 19.9767 12.3197 19.9865C12.3376 19.9962 12.3578 20.0009 12.3782 20C14.0571 19.9186 15.6678 19.311 16.9822 18.2633C18.2965 17.2155 19.2479 15.7807 19.7014 14.1622C20.155 12.5437 20.0877 10.8235 19.5092 9.2453C18.9307 7.66712 17.8703 6.31098 16.4782 5.36901H16.4802Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_772_35516",
    x1: 9.88235,
    y1: -2.48554e-7,
    x2: 17.5462,
    y2: 22.9916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#0096D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA95FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeTt);
export default __webpack_public_path__ + "static/media/veTT.90364cb912725abd834d2fc3637c9d78.svg";
export { ForwardRef as ReactComponent };